export default __webpack_public_path__ + "static/media/griffon3.f7d271e6.png";